import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GtmService {
  private initialized = false;
  private get dl(): any[] {
    (window as any).dataLayer = (window as any).dataLayer || [];
    return (window as any).dataLayer;
  }

  init(gtmId: string): void {
    if (this.initialized || !gtmId) return;
    this.initialized = true;

    this.dl.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

    const firstScript = document.getElementsByTagName('script')[0];
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    firstScript?.parentNode?.insertBefore(script, firstScript);
  }

  pushData(data: Record<string, unknown>): void {
    this.dl.push(data);
  }

  pushEvent(eventName: string, data: Record<string, unknown> = {}): void {
    this.dl.push({ event: eventName, ...data });
  }
}
